import { MockPath } from '@library/common/http/mock-path.mock';

import { ActivityFeedRoutes } from './activityfeed/activityfeed.routes.mock';
import { AddressbookRoutes } from './addressbook/addressbook.routes.mock';
import { AttachmentRoutes } from './attachment/attachment.routes.mock';
import { InvoicesRoutes } from './invoices/invoices.routes.mock';
import { ReportsRoutes } from './reports/reports.routes.mock';
import { ShipmentRoutes } from './shipment/shipment.routes.mock';
import { ShipmentsRoutes } from './shipments/shipments.routes.mock';
import { TemplatesRoutes } from './templates/templates.routes.mock';
import { UserRoutes } from './user/user.routes.mock';
import { QuotationRoutes } from './quotations/quotations.routes.mock';
import { QuotationsRoutes } from './quotations/quotation.routes.mock';

export const ModulesRoutes: MockPath<unknown>[] = [
   ...ActivityFeedRoutes,
   ...AddressbookRoutes,
   ...AttachmentRoutes,
   ...InvoicesRoutes,
   ...ReportsRoutes,
   ...ShipmentRoutes,
   ...ShipmentsRoutes,
   ...TemplatesRoutes,
   ...UserRoutes,
   ...QuotationsRoutes,
   ...QuotationRoutes,
];
